import { storeToRefs } from "pinia";
import { DisplayType, FieldType, FormCabDesigntDto, FormConfig, FormDesignDto, FormDesignItemDto, FormSectionDesignDto, FormulaAssignableItem, ItemMultiDrawarer, ItemsType, ITEMSWITHTAGS, ITEMSWITHVALUE, SelectedItemType } from "./surveyDesignDtos";
import { ResponseContext, SurveyResponseDto, SurveyResponseItemDto } from "./surveyResponseDtos";
import { SurveyState } from "./surveyState";
import { computed, ref, Ref } from "vue";
import { GlobalState } from "../global/gobalState";
import { roles } from "@/shared/globaEnums";
import { Form_status } from "../forms/dtos";
import { Sh } from "@/core/sharedService";
export interface TagValueWeighObject {
    value: number;
    weight: number;
    type: FieldType;
    hasValue: boolean;
    isReference?: boolean;
}
export class SurveyBaseStore{

  // State:
    // Design
  newDesign:  () => void;
  setDesign:  (form: FormDesignDto) => void;
  setCab: (cab: FormCabDesigntDto) => void;
  setMode:  (mode: DisplayType) => void;
  selectItem: (id: string) => void;
  setSelectedType: (type: SelectedItemType) => void;
  addItem: (item: FormDesignItemDto) => void;
  removeItem:  (item: FormDesignItemDto) => void;
  setDesignMode: (design: boolean) => void;
  updateItem: (FormDesignItemDto) => void;
  asignItem: (oldItem: FormDesignItemDto, newItem: FormDesignItemDto) => void;
  release: () => void;
    // Response
  newResponse: (entityId: string, userId: string) => void;
  addResponseItem: (item: FormDesignItemDto, value: any, userId: string) => void;
  setResponse: (response?: SurveyResponseDto, entityId?: string, userId?: string) => void;
  formatValue: (responseItem: SurveyResponseItemDto, designItem: FormDesignItemDto) => void;
  changeReponseValue: (item: FormDesignItemDto, newValue: any) => void;
  changeStatus: (newStatus: Form_status) => void;
  getTagsWithValues :  () =>  {};
  loading: Ref<boolean>;
  errors: Ref<string[]>;
  selectedType: Ref<SelectedItemType>;
  currentDesign: Ref<FormDesignDto>;
  displayMode: Ref<DisplayType>;
  selectedSectionId: Ref<string>;
  selectedItemId: Ref<string>;
  currentResponse: Ref<SurveyResponseDto>;
  isDesign: Ref<boolean>;
  currentItem: Ref<FormDesignItemDto>;


  // Computed
  hasError: Ref<boolean>;
  isNew: Ref<boolean>;
  cab: Ref<FormCabDesigntDto>;
  config: Ref<FormConfig>;
  header: Ref<string>;
  footer: Ref<string>;
  items: Ref<FormDesignItemDto[]>;
  itemsOrganized: Ref<FormSectionDesignDto[]>;// = ref([]);
  
  currentSection: Ref<FormSectionDesignDto>;
  responseContext: Ref<ResponseContext>;
  canClose: Ref<boolean>;
  canAcept: Ref<boolean>;
  responseStatus: Ref<{requireds: number, response: number, result: number}>;
  formulaAssignable: Ref<FormulaAssignableItem[]>; // Computed
  tagsWithValues: Ref<{}>;
  state = SurveyState();

  constructor() {
   this.init(); // load state.
  }

  init = () => {
    // Imports methods from state.
  //#region create instances state
    const st = this.state;
    const {
      newDesign,
      setDesign,
      setCab,
      setMode,
      selectItem,
      setSelectedType,
      addItem,
      removeItem,
      setDesignMode,
      updateItem,
      newResponse,
      addResponseItem,
      asignItem,
      setResponse,
      formatValue,
      changeReponseValue,
      release,
      changeStatus,
    } = st;
    this.release = release;
    this.newDesign = newDesign;
    this.setDesign = setDesign;
    this.setCab = setCab;
    this.setMode = setMode;
    this.selectItem = selectItem;
    this.setSelectedType = setSelectedType;
    this.addItem = addItem;
    this.removeItem = removeItem;
    this.setDesignMode = setDesignMode;
    this.updateItem = updateItem;
    this.asignItem = asignItem;
    // Response
    this.newResponse = newResponse;
    this.addResponseItem = addResponseItem;
    this.setResponse = setResponse;
    this.formatValue = formatValue;
    this.changeReponseValue = changeReponseValue;
    this.changeStatus = changeStatus;
    // state:
      const {
        selectedType,
        currentDesign,
        displayMode,
        selectedSectionId,
        selectedItemId,
        isDesign,
        responseStatus,
        itemsOrganized,
        currentRespone,
        currentItem,
      } = storeToRefs(st);
      this.selectedType = selectedType;
      this.currentDesign = currentDesign;
      this.displayMode = displayMode;
      this.selectedSectionId = selectedSectionId;
      this.selectedItemId = selectedItemId;
      this.currentResponse = currentRespone;
      this.itemsOrganized = itemsOrganized;
      this.responseStatus = responseStatus;
      this.currentItem = currentItem;
      this.isDesign = isDesign;
      this.loading = ref(false);
      this.errors = ref([]);
  //#endregion create instances de estate.






    const {currentContext} = GlobalState();
  //#region propiedades computadas
    // Computed:
      this.hasError = computed(() => this.errors.value.length!=0);
      this.isNew = computed(() => this.currentDesign.value.cab.id == null || this.currentDesign.value.cab.id.trim().length == 0);
      this.cab = computed(() => this.currentDesign && this.currentDesign.value.cab ? this.currentDesign.value.cab : null);
      this.config = computed(() => this.cab && this.cab.value.config ? this.cab.value.config : null);
      this.header = computed(() => this.config ? this.config.value.header : null);
      this.footer = computed(() => this.config ? this.config.value.footer : null);
      this.items = computed(() => this.currentDesign.value.items);
      

      this.currentSection = computed(()=>{
        if(this.selectedSectionId.value.trim().length){
          return this.itemsOrganized.value.find(i => i.section.id == this.selectedSectionId.value);
        }
        if(this.currentItem.value!=null && ![FieldType.SECTION, FieldType.NEWPAGE].includes(this.currentItem.value.type)){
          return this.itemsOrganized.value.find(i => i.section.id == this.currentItem.value.parentItemId);
        }
        return null;
      });

      this.responseContext = computed<ResponseContext>(() => {
        const context = new ResponseContext();
        const role = currentContext.user.role;
        switch(role){
          case roles.CLIENT:
          case roles.GROUP:
          case roles.ROOT:
          case roles.USER:
              context.displayMode = this.displayMode.value == DisplayType.EDIT ? DisplayType.DISPLAY : this.displayMode.value;
            break;
          case roles.ENTITY:
            if(this.currentResponse.value && [Form_status.CLOSED, Form_status.VALIDATED].includes(this.currentResponse.value.state)){
              context.displayMode = this.displayMode.value == DisplayType.EDIT ? DisplayType.DISPLAY : this.displayMode.value;
            }else if(!this.currentResponse.value.items.length){
              context.displayMode = DisplayType.DISPLAY;
            }else {
              context.displayMode = this.displayMode.value;
            }
        }
        if(!this.currentResponse.value || !this.currentResponse.value.items.length) return context;
        context.state = this.currentResponse.value.state;
        context.canAprobe = this.currentResponse.value.state == Form_status.CLOSED &&  currentContext.user.role === roles.CLIENT;
        context.canClose  = true;
        for(const d of this.currentDesign.value.items){
          if(d.response && d.required && !d.response.value){
            context.canClose = false;
            break;
          }
        }
        context.canEdit  = currentContext.user.role == roles.ENTITY;
        return context;
      });
      
      const getItemsFormAasignable = (it: FormDesignItemDto) : FormulaAssignableItem[] => {
        if(![FieldType.GRID, FieldType.EXCELGRID].includes(it.type)) return [];
        const items: FormulaAssignableItem[] = [];
        const response = it.response;
        switch(it.type){
          case FieldType.GRID:

            for(const i of it.items){
              let value = 0;

              if(it.itemsType!=ItemsType.NUMBER || (!response || !response.value || !response.value.length)){
                value = 0;
              } else{
                value =  it.response.value[it.items.findIndex(ii => ii.tag == i.tag)] ?? 0;
              }
              

              items.push(<FormulaAssignableItem>{
                tag: i.tag,
                label: i.label,
                hasValue: it.itemsType == ItemsType.NUMBER,
                weight: i.value,
                value: value,
                type: FieldType.NUMBER,
                isReference: false
              })
            }
            break;
          case FieldType.EXCELGRID:
            for(const [index, i] of it.gridDesign.headers.entries()){
              const curHead: FormulaAssignableItem = {
                tag: "",
                label: i,
                hasValue: false,
                weight: 0,
                value:  0,
                isInherits: !Sh.isNullOrEmptyOrZero(it.inheritItemId),
                type: FieldType.NUMBER,
                isReference: false, 
                items: []
              };
              
              for(const [indexRow, r] of it.gridDesign.rows.entries()){
                curHead.items.push(<FormulaAssignableItem>{
                  tag: r.cells[index].tag,
                  isReference: r.cells[index].isReference ?? false,
                  label: r.title,
                  hasValue: true,
                  isInherits: curHead.isInherits,
                  weight: response && response.value && response.value.length ? response.value[indexRow][index] ?? 0 : 0,
                  value: response && response.value && response.value.length ? response.value[indexRow][index] ?? 0 : 0,
                  type: FieldType.NUMBER,
                });
              }
              items.push(curHead)
            }


            
            break;

       }
       return items;
      }

      const getValueWeight = (it: FormDesignItemDto): {value: number, weight: number} => {
        const res = {
          value: 0,
          weight: 0
        }
        const arrayValue:boolean = it.response?.value && Array.isArray(it.response.value) && it.response.value.length ? true : false;
        const objectValue:boolean = it.response?.value && typeof it.response.value === 'object' && !Array.isArray(it.response.value) && Object.keys(it.response.value).length > 0
        switch(it.type){
          case FieldType.NUMBER:
            res.value = it.response?.value ?? 0;
            res.weight = it.response?.value ? it.weight : it.weightEmpty;
            break;
          case FieldType.TEXT:
            res.value = 0;
            res.weight = it.response?.value.trim().length ? it.weight : it.weightEmpty;
            break;
          case FieldType.DROPDOWN:
            res.value = arrayValue ? it.items[it.response.value[0]].value : 0;
            res.weight = arrayValue ? it.items[it.response.value[0]].value  : it.weightEmpty;
            break;
          case FieldType.MULTYDROPDOWN:
            if(!arrayValue){
              res.weight = it.weightEmpty;
              res.value = it.weightEmpty;
            }else{
              res.weight = it.weight;
              for(const i of it.response.value){
                res.value += it.items[i].value;
              }
            }
            break;
          case FieldType.DATERANGE:
            if(!objectValue  ){
              res.weight = it.weightEmpty;
              res.value = it.weightEmpty;
              break;
            }
            if(!it.response.value.init || !it.response.value.end || it.response.value.init.trim().length == 0 || it.response.value.end.trim().length == 0){   
              res.weight = it.weightEmpty;
              res.value = it.weightEmpty;
              break;
            }
            res.weight = it.weight;
            res.value = (new Date(it.response.value.end).getTime() - new Date(it.response.value.init).getTime()) / 1000 / 86400;
            break;
          case FieldType.DATE:
            if(it.response?.value && it.response.value.trim().length){
              res.weight = it.weight;
              res.value = it.weight
            }else{
              res.weight = it.weightEmpty;
              res.value = it.weightEmpty;
            }
            break;
          case FieldType.FILE:
            if(it.response?.value && it.response.value.id && it.response.value.id.trim().length)
            {
              res.weight = it.weight;
              res.value = it.weight;
            }else{
              res.weight = it.weightEmpty;
              res.value = it.weightEmpty;
            }
            break;
          case FieldType.YESNO:
              res.weight = it.response?.value ? it.weight : it.weightEmpty;
              res.value = it.response?.value ? it.weight : it.weightEmpty;
            break;
          case FieldType.APIREST:
            res.weight = it.response?.value ? it.response.value : 0;
            res.value = it.response?.value ? it.response.value : 0;
            break;            
        }
        return res;

      }
      const assignableFormule = () => {
        const items = this.currentDesign.value.items
          .filter(i => Object.keys(ITEMSWITHTAGS).includes(i.type) )
          .map<FormulaAssignableItem>((it: FormDesignItemDto) => 
          {
            const {value, weight} = getValueWeight(it);            
            const ret =  <FormulaAssignableItem>{
            tag: it.tag, 
            type: it.type, 
            label: it.label, 
            weight: weight,
            value: value,
            hasValue: ITEMSWITHVALUE[it.type] ?? false, 
            isReference: false,
            items: getItemsFormAasignable(it)
          };
          if(it.type == FieldType.GRID){
            ret.weight = ret.items.reduce((sum, item) => sum + item.value, 0) ? it.weight : it.weightEmpty;
            ret.value = ret.weight;
          }
          
          return ret;
          });
          return items;

      }
      this.formulaAssignable = computed<FormulaAssignableItem[]>(() => 
        {
        const items = this.currentDesign.value.items
          .filter(i => Object.keys(ITEMSWITHTAGS).includes(i.type) )
          .map<FormulaAssignableItem>((it: FormDesignItemDto) => 
          {
            const {value, weight} = getValueWeight(it);           
            let label = it.label;
            if(it.type == FieldType.EXCELGRID) {
              label = `${it.gridDesign.rows.length!=0 ? it.gridDesign.rows[0].title : ''} (ExcelGrid)`;
            }
            const ret =  <FormulaAssignableItem>{
            tag: it.tag, 
            type: it.type, 
            label: label, 
            weight: weight,
            value: value,
            isInherits: !Sh.isNullOrEmptyOrZero(it.inheritItemId),
            hasValue: ITEMSWITHVALUE[it.type], 
            isReference: false,
            items: getItemsFormAasignable(it)
          };
          ret.weight = ret.items.reduce((sum, item) => sum + item.value, 0) ? it.weight : it.weightEmpty;
          ret.value = ret.weight;
          return ret;
          });
          return items;
        });
        
      this.tagsWithValues = computed<{}>(() => {
       return this.getTagsWithValues();
      })
      
      this.getTagsWithValues = ():{[key: string]: TagValueWeighObject}  => {
        let tags: {[key: string]: TagValueWeighObject} = {};
        var forms = assignableFormule();
        try {
          
          for(const i of forms){

            if(i.type == FieldType.GRID){

              for(const it of i.items){
                
                tags[it.tag] = {value: it.value, weight: it.value ?  it.weight : 0, type: i.type, hasValue: i.hasValue, isReference: i.isReference};
              }
              
            }
            if(i.type == FieldType.EXCELGRID){
              for(const it of i.items){
               // tags[it.tag] = {value: it.value, weight: it.weight, type: i.type, hasValue: i.hasValue, isReference: i.isReference};
                if(it.items && it.items.length){
                  for(const itt of it.items.filter(f => !f.isReference )){
                    tags[itt.tag] = {value: itt.value, weight: itt.weight, type: i.type, hasValue: i.hasValue, isReference: i.isReference};
                  }
                }
              }
            } 
            if(![FieldType.GRID, FieldType.EXCELGRID].includes(i.type)){
              tags[i.tag] = {value: i.value, weight: i.weight, type: i.type, hasValue: i.hasValue, isReference: i.isReference};
              continue;
            }
 
          }  





        } catch (error) {
          console.error(error);
        }
        
        return tags;
      }
  //#endregion propiedades computadas
}


    isNotEmptyValue(design: FormDesignItemDto): boolean{
      const response: SurveyResponseItemDto = design.response;
      if(!response) return false;
        switch(design.type){
          case FieldType.NUMBER:
          case FieldType.FORMULE:          
            return response.value !=0;
          case FieldType.TEXT:
          case FieldType.DATE:
            return response.value.trim() !="";
          case FieldType.DROPDOWN:
          case FieldType.MULTYDROPDOWN:
            return response.value.length !=0;
          case FieldType.DATERANGE:
            return response.value["init"].trim() != "" && response.value["end"].trim() != "";
          case FieldType.FILE: 
            return response.value["id"].trim() != "";
          case FieldType.GRID:
            return response.value.length && response.value.find(v => v == undefined || v == null || v.trim()== "")== null;
        }
    }
}